"use strict";

define('controller/board/list',['require','exports','module','backbone','underscore','../base','../../config','../../model/board','../../libs/route.helper','langs','uikit/uikit','../../view/table.ellipsis','../../view/page.list','../../view/empty.table'],function (require, exports, module) {
  var Backbone = require('backbone');
  var _ = require('underscore');
  var RegionController = require('../base');
  var config = require('../../config');
  var BoardModel = require('../../model/board');
  var RouteHelper = require('../../libs/route.helper');
  var langs = require('langs');
  var UIKit = require('uikit/uikit');
  var TableEllipsis = require('../../view/table.ellipsis');
  var PageList = require('../../view/page.list');
  var EmptyTableView = require('../../view/empty.table');
  var CheckboxView = UIKit.Checkbox;
  var ButtonView = UIKit.Button;
  function setupActiveColumn(view, model) {
    view.model = model;
    view.bindings.value = 'active';
    view.toggle = true;
    view.polar = true;
    view.listenTo(model, 'change:active', function () {
      model.save();
    });
  }
  ;
  function setupTableEllipsisOptions() {
    var model = this.model;
    return {
      collection: new Backbone.Collection([{
        text: 'Edit',
        icon: 'pencil',
        link: generateBoardLink(model)
      }, {
        text: 'Delete',
        icon: 'trash',
        action: 'remove'
      }]),
      childBindings: {
        text: 'text',
        icon: 'icon',
        link: 'link'
      },
      ariaLabel: 'manage board'
    };
  }
  ;
  function createNewBoardButton() {
    return new ButtonView({
      text: 'New Board',
      icon: 'plus',
      color: 'primary',
      link: new RouteHelper('board:create').get('link')
    });
  }
  ;
  function generateBoardLink(model) {
    return RouteHelper.createLink(model.isNew() ? 'board:create' : 'board:detail', model, {
      boardId: 'id'
    });
  }
  ;
  var BOARD_COLUMNS = [{
    text: 'Manage',
    useAccessibilityText: true,
    childView: TableEllipsis,
    collapsing: true,
    childViewOptions: setupTableEllipsisOptions
  }, {
    text: 'Name',
    data: 'name'
  }, {
    text: 'Active',
    childView: CheckboxView,
    onBeforeAdd: setupActiveColumn
  }];
  var BoardListController = RegionController.extend({
    header: langs.phrase('App.Title'),
    authorities: ['PERM_IRB_ADMIN'],
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state;
      var root = new PageList({
          search: false,
          sectionTitle: langs.phrase('Settings.ReviewBoards.List.Title'),
          useTableHeaderForLabel: false
        }),
        table = root.table,
        boards = BoardModel.all();
      var COLUMNS = _.clone(BOARD_COLUMNS);
      COLUMNS[0] = _.clone(COLUMNS[0]);
      COLUMNS[0].onBeforeAdd = function (view, model) {
        var currentRowView = this;
        view.on('action', function (child, action) {
          rowActionPress(model, action, currentRowView);
        });
      };
      function rowActionPress(board, action, rowView) {
        switch (action.get('action')) {
          case 'remove':
            app.request('modal', {
              type: 'CONFIRM_DESTROY',
              state: state,
              entity: 'Board',
              name: board.get('name')
            }, {
              ariaControlsId: rowView.cid
            }).on('confirm', function () {
              board.destroy({
                wait: true
              });
            });
            break;
        }
      }
      ;
      root.$el.css(config.contentCss);
      root.setupColumns(COLUMNS).addRightHeaderItem(createNewBoardButton()).setupEmptyView(EmptyTableView.Row, {
        text: "You have no review boards",
        headerTag: 'h4'
      });
      table.sortable = false;
      table.collection = boards;
      table.selection = 'single';
      table.selectable = true;
      table.useTableHeaderForLabel = false;
      table.ariaLabel = langs.phrase('Settings.ReviewBoards.List.Title');
      root.listenTo(table, 'row:double:press', function (row) {
        app.navigate(generateBoardLink(row.model).slice(1), {
          trigger: true
        });
      });
      state.addPageDependencies([boards]).on('page:loaded', function () {
        region.show(root);
      }).on('page:cancel', function () {
        root.destroy();
      });
      boards.fetch();
    }
  });
  module.exports = BoardListController;
});

